import { z } from 'zod';

export const userSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  username: z.string().nullable(),
  locale: z.string().nullable(),
  language: z.string(),
  colorScheme: z.string().default('auto').optional(),
  uiScaleDesktop: z.number().default(100).optional(),
  uiScaleMobile: z.number().default(100).optional(),
  /** IANA timezone name last reported by the user's browser; null until first reported. */
  timezone: z.string().nullable().optional(),
  displayName: z.string(),
  emailVerified: z.date().nullable(),
  image: z.string().nullable(),
  email: z.string(),
  role: z.enum(['admin', 'member', 'client', 'system']).optional(),
  status: z.enum(['pending', 'accepted', 'rejected', 'deleted']).optional(),
  clientIds: z.array(z.string()).optional(),
  archived: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type UserSchema = z.infer<typeof userSchema>;
